import React from "react";
import {
  ThemeProvider as MUIThemeProvider,
  createTheme,
} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { API_URL } from "./constants";
import AppRoutes from "./AppRoutes";
import { AuthProvider } from "./Context/AuthContext";
import { useAppTheme } from "./Context/ThemeContext";
import { GetMeProvider } from "./Context/GetMeContext";
import { GlobalStyles } from "@mui/material";
import { onError } from "@apollo/client/link/error";
import { darkTheme } from "./themes/darkTheme";
import { lightTheme } from "./themes/lightTheme";
import { GetCookLaterRecipeProvider } from "./Context/GetCookLaterRecipeContext";
import { KitchenDetailProvider } from "./Context/GetMyKitchenDetailContext";
import { MyInventoryProvider } from "./Context/MyInventoryContext";

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("autoChef_authToken");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      "Apollo-Require-Preflight": "true",
    },
  };
});

const uploadLink = createUploadLink({
  uri: API_URL,
  headers: {
    "Apollo-Require-Preflight": "true",
  },
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
      if (message.includes("Unauthorized")) {
        localStorage.removeItem("autoChef_authToken");
        window.location.href = "/login";
      }
    });
  }
  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

const client = new ApolloClient({
  link: errorLink.concat(authLink).concat(uploadLink),
  cache: new InMemoryCache(),
});

const App = () => {
  const { darkMode } = useAppTheme();

  const theme = createTheme(darkMode ? darkTheme : lightTheme);

  return (
    <ApolloProvider client={client}>
      <AuthProvider>
        <MUIThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles
            styles={{
              "::-webkit-scrollbar": {
                width: "8px",
              },
              "::-webkit-scrollbar-track": {
                backgroundColor: theme.palette.background.paper,
                borderRadius: theme.shape.borderRadius,
              },
              "::-webkit-scrollbar-thumb": {
                backgroundColor: theme.palette.primary.main,
                borderRadius: theme.shape.borderRadius,
                border: `2px solid ${theme.palette.background.paper}`,
              },
              "::-webkit-scrollbar-thumb:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
              "*": {
                scrollbarWidth: "thin",
                scrollbarColor: `${theme.palette.primary.main} ${theme.palette.background.paper}`,
              },
            }}
          />
          {/* <GetMeProvider> */}

          <AppRoutes />

          {/* </GetMeProvider> */}
        </MUIThemeProvider>
      </AuthProvider>
    </ApolloProvider>
  );
};

export default App;
